module.exports = __webpack_public_path__ + "static/media/TLYFEPROlLOGI.730780ed.svg";